import {Injectable} from '@angular/core';

import {FilterItem} from '../../../+reports/reports.interfaces';
import {FieldType} from '../../../shared/form-generator/fields/fields.interfaces';
import {Entity} from '../../../shared/population/create-population/create-population.interfaces';
import {TreeNode} from '../../../shared/ui';
import {TreeItem} from '../../../shared/ui/tree-multi-select/treeview.component';

export const getEntityLazyValue = (id: number | string, entityList: Entity[]): string => {
  let res = null;
  if (entityList?.length > 0) {
    const selectedEntity: Entity = entityList?.find(entity => entity.id < 0 ? entity.id * -1 === id : entity.id === id);
    res = selectedEntity ? selectedEntity.name : null;
  }

  return res;
};

export const isListType = (zoneType): boolean => {
  return zoneType === FieldType.LIST;
};

export const isTreeType = (zoneType): boolean => {
  return zoneType === FieldType.TREE;
};

export const isEntityType = (zoneType): boolean => {
  return zoneType === FieldType.ENTITY || zoneType === FieldType.ENTITY_DATA || zoneType === FieldType.ENTITY_PREFIXED;
};

export const isDateType = (zoneType): boolean => {
  return zoneType === FieldType.DATE;
};

export const isBooleanType = (zoneType): boolean => {
  return zoneType === FieldType.BOOLEAN;
};

@Injectable({
  providedIn: 'root'
})
export class ManageAccessCriterionModalService {

  public createListTree(list: FilterItem[]): TreeNode<TreeItem>[] {
    return list.map(item => ({
      text: item.display,
      value: item.value,
      selectable: true,
      visible: true,
      children: []
    }));
  }

  public createTree(filterItems: FilterItem[]): TreeNode<TreeItem>[] {
    const lookupMap: Map<string, TreeNode<TreeItem>> = new Map<string, TreeNode<TreeItem>>();
    const zoneTypeTree = new Array<TreeNode<TreeItem>>();

    filterItems.forEach((item: FilterItem) => lookupMap.set(item.value, {
      text: item.display,
      value: item.value,
      data: item.parentValue,
      selectable: item.selectable,
      visible: true,
      children: []
    }));

    for (const item of Array.from(lookupMap.values())) {
      const parent: TreeNode<TreeItem> = lookupMap.get(item.data?.toString());
      if (parent !== undefined) {
        parent.children.push(item);
      } else {
        zoneTypeTree.push(item);
      }
    }

    return zoneTypeTree;
  }
}
